<template>
  <div class="wrap">
    <header class="header">
      <span class="iconfont icon-back-left" @click="goBack"></span>
      <h2>我的矿机</h2>
    </header>
    <div class="main">
      <div class="list">
        <p class="title">产品名称：BTT</p>
        <p><span><i>申购金额：</i>100 USDT</span></p>
        <p><span><i>中签金额：</i>0.00 USDT</span></p>
        <p><span><i>申购时间：</i>2021-12-04 06:40:34</span></p>
        <p><span><i>上线时间：</i>2021-12-08 06:40:34</span></p>
        <p>
          <span><i>订单号：</i>132421354</span>
          <span class="btn green">申购中</span>
        </p>
      </div>
      <div class="list">
        <p class="title">产品名称：BTT</p>
        <p><span><i>申购金额：</i>100 USDT</span></p>
        <p><span><i>中签金额：</i>0.00 USDT</span></p>
        <p><span><i>申购时间：</i>2021-12-04 06:40:34</span></p>
        <p><span><i>上线时间：</i>2021-12-08 06:40:34</span></p>
        <p>
          <span><i>订单号：</i>132421354</span>
          <span class="btn grey">已过期</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import {
		mapState
	} from 'vuex'
  export default {
    data() {
      return {
        
      }
    },
    computed: {
			...mapState(['lang'])
		},
    mounted() {
      
    },
    methods:{
      goBack() {
        this.$router.go(-1)
      }
    }
  }
</script>
<style  scoped>
  .main{
    background: #f5f5f5;

    .list{
      margin:12px;
      background: #fff;
      padding:12px;
      border-radius: 8px;
      p{
        line-height: 24px;
        color:#333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.title{
          font-size: 16px;
          font-weight: bold;
        }
        .progress{
          flex:1;
        }

        i{
          color:#999;
        }
        .btn{
          margin-left:30px;
          padding:2px 10px;
          color:#fff;
          border-radius: 5px;
          background: #F56867;

          &.grey{
            background: #8a8a8a;
          }

          &.green{
            background: #03ad90;
          }
        }
      }
    }
  }
</style>